import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './ClientApplicationListLayout.resolver';
import ClientApplicationListLayout from './ClientApplicationListLayout';

export default async(resolver, { context: RootStoreContext })(
  ClientApplicationListLayout
);
